module.exports = "https://99designs-start-assets.imgix.net/js/638abefeecdb2e997b0a67f4cf451f6b.png";